export default __webpack_public_path__ + "static/media/42.84de5f7b.jpg";